<template>
  <b-modal
    id="modal-confirm"
    hide-footer
    centered
    :noCloseOnBackdrop="loading"
    :noCloseOnEsc="loading"
    :hideHeaderClose="loading"
  >
    <div class="col-12 d-flex flex-column align-items-center modalsTables">
      <img
        class="centerImg1"
        src="@/assets/images/icons/alert-line.svg"
        width="20%"
      />
      <h3 class="pt-3 font-weight-bold mb-4">
        {{ confirmation.text }}
      </h3>
      <b-alert show variant="warning" class="alert-warning-message">
        <div class="d-flex">
          <div class="mr-3">
            <img
              src="@/assets/images/icons/alert-line.svg"
              alt=""
              width="28px"
              height="28px"
            />
          </div>
          <p style="font-size: 14px; color: #263238; margin-bottom: 0">
            Al confirmar no podrás recuperar los cambios.
          </p>
        </div>
      </b-alert>

      <div
        class="w-100 mt-4 d-flex align-content-center justify-content-center"
      >
        <button
          class="button_danger_modal mr-5"
          @click.prevent="() => $emit('deleteItem')"
          :disabled="loading"
        >
          <span class="cta">Borrar</span>
          <b-spinner v-if="loading" />
        </button>
        <button
          class="button-secundary"
          @click="$bvModal.hide('modal-confirm')"
          :disabled="loading"
          style="margin: 0; padding: 8px 16px; border-radius: 8px"
        >
          <span class="cta">No borrar</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    confirmation: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped></style>
